import { ParsedFactorData } from "pages/register/types/parsedTransactionFactorData";
import { Factor, FactorData } from "types/factor/factor";

const buildFactorLists = (
  factorData: FactorData | ParsedFactorData,
): Factor[][] => {
  const { factorMap, factorOrder } = factorData;
  const activeFactors: Factor[] = [];
  const inactiveFactors: Factor[] = [];

  factorOrder.forEach((factorKey) => {
    const factor = factorMap[factorKey];
    if (factor) {
      const targetList = factor.flags.isActive
        ? activeFactors
        : inactiveFactors;
      targetList.push(factor);
    }
  });

  return [activeFactors, inactiveFactors];
};

export default buildFactorLists;
